import { mixpanel, bigQuery, stats } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

const sendBigQuery = (type, addedParams) => {
    const { origin, sellerName, sellerId, videoUrl } = addedParams;
    const { userId, pageCtxId, userGuid } = getContext();
    const fullParams = {
        type,
        user: {
            id: userId
        },
        uid: userGuid,
        group: 'user_actions',
        entity: 'client',
        page: {
            ctx_id: pageCtxId,
            name: origin,
            component: {
                metadata: videoUrl
            }
        },
        seller: {
            id: sellerId,
            username: sellerName
        }
    };

    bigQuery.send(fullParams);
};

const METRIC_PREFIX = 'packages.profile_image.intro_video.client';

const introVideoImpression = (params) => {
    mixpanel.track('IntroVideo - Avatar Impression', params);
    sendBigQuery('intro_video_impression', params);
    stats.count(METRIC_PREFIX, 'impression');
};

const introVideoHover = (params) => {
    mixpanel.track('IntroVideo - Avatar Hover', params);
    sendBigQuery('intro_video_hover', params);
    stats.count(METRIC_PREFIX, 'hover');
};

const introVideoOpenModal = (params) => {
    mixpanel.track('IntroVideo - Open Modal', params);
    sendBigQuery('intro_video_clicked', params);
    stats.count(METRIC_PREFIX, 'clicked');
};

const introVideoCloseModal = (params) => {
    mixpanel.track('IntroVideo - Close Modal', params);
};

const introVideoModalEnded = (params) => {
    mixpanel.track('IntroVideo - Full View', params);
};

const introVideoExists = (params) => {
    mixpanel.track('IntroVideo - Exists', params);
};

const introVideoError = (src, params = {}) => {
    mixpanel.track('IntroVideo - Error', { ...params, src });
    stats.count(`${METRIC_PREFIX}.error`, src);
};

export {
    introVideoImpression,
    introVideoHover,
    introVideoOpenModal,
    introVideoCloseModal,
    introVideoModalEnded,
    introVideoExists,
    introVideoError
};
